export enum TriggerCategory {
  AgentStatsProcesses = 'agent-stats-processes',
  AgentStatsSummaryCPU = 'agent-stats-summary-cpu',
  AgentStatsSummaryMemory = 'agent-stats-summary-memory',
  AgentStatsSummaryDisk = 'agent-stats-summary-disk',
  AgentStatsSummaryNetwork = 'agent-stats-summary-network',
  AgentStatsSummarySystem = 'agent-stats-summary-system',
  AgentStatsSummaryGPU = 'agent-stats-summary-gpu'
}
